import { NgModule } from '@angular/core';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { IntegrationDisplayComponent } from './integration-display/integration-display.component';
import { SidexisModule } from './sidexis/sidexis.module';
import { EzdentModule } from './ezdent/ezdent.module';
import { TwainModule } from './twain/twain.module';
import { RomexisModule } from './romexis/romexis.module';
import { RomexisV2Module } from './romexis-v2/romexis-v2.module';
import { VixWinModule } from './vixwin/vixwin.module';
import { CliniviewModule } from './cliniview/cliniview.module';
import { DentalEyeModule } from './dentaleye/dentaleye.module';
import { IDixelModule } from './idixel/idixel.module';
import { VistaSoftModule } from './vistasoft/vistasoft.module';
import { DtxStudioModule } from './dtx-studio/dtx-studio.module';

@NgModule({
  imports: [
    SidexisModule,
    NgSharedModule,
    EzdentModule,
    TwainModule,
    RomexisModule,
    RomexisV2Module,
    VixWinModule,
    CliniviewModule,
    DentalEyeModule,
    IDixelModule,
    VistaSoftModule,
    DtxStudioModule,
    IntegrationDisplayComponent,
  ],
  exports: [
    SidexisModule,
    IntegrationDisplayComponent,
    EzdentModule,
    TwainModule,
    RomexisModule,
    RomexisV2Module,
    VixWinModule,
    CliniviewModule,
    DentalEyeModule,
    IDixelModule,
    VistaSoftModule,
    DtxStudioModule,
  ],
})
export class IntegrationsModule {}
